import React, { Fragment } from "react";
import PropTypes from "prop-types";
import "./style.less";
import AnchorLink from 'react-anchor-link-smooth-scroll'
import utils from "../../utils/utils";

function debounce(fn, delay) {
  let timer = null //借助闭包
  return function () {
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(fn, delay) // 简化写法
  }
}

class PipelineNavBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      checkedNav: '',
      navFixed: false,
      select: 0,
      navList: []
    };
    this.navigationContentHeight = 52;
    // 滚动事件监听
    if (typeof window !== 'undefined') {
      window.addEventListener('scroll', (e) => {
        this.handleBodyScroll()
      });
    }
  }

  componentDidMount() {
    const { baseConfig, itemList } = this.props.config;
    if (baseConfig.navigationStyle === '图片导航') {
      const { navList = [] } = this.props;
      const navListFilter = [];
      navList.forEach(item => {
        const findItem = navListFilter.find(value => value.title === item.title);
        if (!findItem) {
          navListFilter.push(item);
        }
      });
      this.setState({
        navList: navListFilter
      }, () => {
        setTimeout(() => {
          const lastNavComp = navListFilter[navListFilter.length - 1];
          const lastNavCompOffsetTop = document.querySelector(`#${lastNavComp.id}`).offsetTop;
          const height = lastNavCompOffsetTop - this.navRef.offsetTop;
          const navRefHeight = this.navRef.clientHeight;
          this.navRef.style.height = `${height}px`;
          this.navRef.style.marginBottom = `${-(height - navRefHeight)}px`;
        }, 1000)
      })
    } else {
      if (baseConfig.navigationType === "模块") {
        this.setState({
          checkedNav: itemList[0]
        })
      }
    }
    // this.handleBodyScroll();
  }

  handleBodyScroll = () => {
    const { navList } = this.state;
    const { baseConfig, itemList } = this.props.config;
    const navigationBarHeight = this.props.navigationBarHeight;
    const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop;
    if (baseConfig.navigationStyle === '图片导航') {
      // 图片导航栏 滚动交互
      for (let index = 0; index < navList.length; index++) {
        const item = navList[index];
        const navComp = window.document.querySelector(`#${item.id}`);
        if (this.navigationWrapRef && navComp && scrollHeight > navComp.offsetTop - this.navigationWrapRef.clientHeight - navigationBarHeight) {
          this.setState({
            select: index,
          });
        }
      }
    } else {
      // 默认导航栏 滚动交互
      const navOffsetTop = window.document.querySelector(baseConfig.navigationType === "模块" ? '.navigation-container-static-two' : '.navigation-container-static').offsetTop - navigationBarHeight;
      const navMarginTop = Number(this.props.config.baseConfig.moduleMarginTop); // 导航模块上边距
      if (scrollHeight - navOffsetTop > navMarginTop) {
        this.setState({
          navFixed: true,
        });
      } else {
        this.setState({
          navFixed: false,
        });
      }

      let checkedNav = '';
      if (baseConfig.navigationType === '模块') {
        checkedNav = itemList[0];
        itemList.map((item) => {
          const productComList = window.document.querySelector(`#${item.id}`);
          if ((scrollHeight + this.navigationContentHeight + navigationBarHeight) > productComList.offsetTop) {
            checkedNav = item;
          }
        })
      } else {
        // 查询当前展示的商品组件
        const productComList = window.document.querySelectorAll('.pipeline-product,.pipeline-productList,.pipeline-goodsRecommend,.pipeline-imgList,.pipeline-image,.pipeline-rank,.pipeline-imgHotMap,.pipeline-community,.pipeline-imgListScroll,.pipeline-imgs') || [];
        for (let i = 0; i < productComList.length; i += 1) {
          // console.log(productComList[i].offsetTop);
          // 模块偏移量小于 滚动偏移 + 导航栏高度，导航栏高度暂定为 45
          if ((scrollHeight + this.navigationContentHeight + navigationBarHeight) > productComList[i].offsetTop) {
            checkedNav = productComList[i].getAttribute('id');
          }
        }
      }
      this.setState({
        checkedNav,
      });
    }
  }

  defaultNavClick = (item, index) => {
    utils.uploadTrack(this.props, {
      sort: index
    });
    const { baseConfig, itemList } = this.props.config;
    // 导航跳转
    this.setState({
      checkedNav: item,
    });
    if (baseConfig.navigationType === '模块') {
      const productComList = window.document.querySelector(`#${item.id}`);
      //window.scrollTo(0, productComList.offsetTop - 42);
      window.scrollTo({
        top: productComList.offsetTop - this.props.navigationBarHeight - (this.navigationContentHeight - 3),
        behavior: "smooth"
      })
    }else{
      // if (typeof window !== 'undefined') {
      //   window.location.href = `#${item}`;
      // }
      const productComList = window.document.querySelector(`#${item}`);
      window.scrollTo({
        top: productComList.offsetTop - this.props.navigationBarHeight - (this.navigationContentHeight - 3),
        behavior: "smooth"
      })
      // 向下继续滚动42单位
      // setTimeout(() => {
      //   const scrollTop = (document.documentElement.scrollTop || document.body.scrollTop) - 42;
      //   window.scrollTo(0, scrollTop);
      // }, 40);
    }
  }

  imgNavClick = (item, index) => {
    const { navList } = this.state;
    const findItem = navList.find(value => value.title === item.navigationTo);
    if (findItem) {
      const { id } = findItem;
      const scrollTo = window.document.querySelector(`#${id}`);
      window.scrollTo({
        top: scrollTo.offsetTop - this.props.navigationBarHeight - this.navigationWrapRef.clientHeight + 3,
        behavior: "smooth"
      })
    }
  }

  // 渲染默认导航栏（‘背景图 + 文字’ 导航）
  renderDefaultNavList = () => {
    const { baseConfig, itemList = [] } = this.props.config;
    let navList = this.props.navList;
    if (baseConfig.navigationType === '模块') {
      navList = itemList;
    }
    return (
      <Fragment>
        <div
          className={baseConfig.navigationType === "模块" ? "navigation-container-static-two" : "navigation-container-static"}
          style={{
            paddingTop: `${baseConfig.moduleMarginTop}px`,
            backgroundColor: baseConfig.bgColor
          }}
        >
          {navList.map((item, index) => {
            return (
              <div
                className="nav-item"
                key={index}
                onClick={this.defaultNavClick.bind(this, item, index)}
                style={{
                  width: baseConfig.bgImage ? '85px' : 'auto',
                  height: baseConfig.bgImage ? '28px' : 'auto',
                  lineHeight: baseConfig.bgImage ? '28px' : 'auto',
                  margin: baseConfig.bgImage ? '2px 8px 12px 8px' : '12px 16px',
                  backgroundImage: baseConfig.bgImage ? `url(${this.state.checkedNav === item ? baseConfig.bgCheckedImage : baseConfig.bgImage})` : 'none',
                  color: this.state.checkedNav === item ? baseConfig.fontCheckedColor : baseConfig.fontColor,
                  fontFamily: this.state.checkedNav === item ? 'PingFangSC-Medium' : 'PingFangSC-Regular',
                  opacity: this.state.checkedNav === item ? 1 : .7,
                  fontSize: baseConfig.fontSize,
                }}
              >
                {baseConfig.navigationType === '模块' ? item.title : item}
                {item.badgeIcon && (<img className="badge-icon" src={utils.formatImgUrl(item.badgeIcon, this.props.webpSupport)} alt="" />)}
              </div>
            )
          })}
        </div>
        <div
          className={baseConfig.navigationType === "模块" ? "navigation-container-fixed-two" : "navigation-container-fixed"}
          style={{
            backgroundColor: baseConfig.bgColor,
            display: this.state.navFixed ?  baseConfig.navigationType === '模块' ? 'flex' : 'block' : 'none',
            top: this.props.navigationBarHeight
          }}
        >
          {navList.map((item, index) => {
            return (
              // offset值为 导航栏高度（45）- 3，暂定为42
              <AnchorLink
                key={index}
                offset={() => {
                  utils.uploadTrack(this.props, {
                    sort: index
                  })
                  return this.props.navigationBarHeight + (this.navigationContentHeight - 3)
                }}
                href={baseConfig.navigationType === '模块' ? `#${item.id}` : `#${item}`}
              >
                <div
                  className="nav-item"
                  key={index}
                  //onClick={this.defaultNavClick.bind(this, item)}
                  style={{
                    width: baseConfig.bgImage ? '88px' : 'auto',
                    height: baseConfig.bgImage ? '28px' : '28px',
                    lineHeight: baseConfig.bgImage ? '28px' : '28px',
                    margin: baseConfig.bgImage ? '12px 2px 12px 2px' : '12px 16px',
                    backgroundImage: baseConfig.bgImage ? `url(${this.state.checkedNav === item ? baseConfig.bgCheckedImage : baseConfig.bgImage})` : 'none',
                    color: this.state.checkedNav === item ? baseConfig.fontCheckedColor : baseConfig.fontColor,
                    fontFamily: this.state.checkedNav === item ? 'PingFangSC-Medium' : 'PingFangSC-Regular',
                    opacity: this.state.checkedNav === item ? 1 : .7,
                    fontSize: baseConfig.fontSize,
                  }}
                >
                  {baseConfig.navigationType === '模块' ? item.title : item}
                  {item.badgeIcon && (<img className="badge-icon" src={utils.formatImgUrl(item.badgeIcon, this.props.webpSupport)} alt="" />)}
                </div>
              </AnchorLink>
            )
          })}
        </div>
      </Fragment>
    )
  }

  // 渲染图片导航栏
  renderImgNavList = () => {
    const { baseConfig, itemImgList = [] } = this.props.config;
    const { navigationBarHeight, backgroundColor } = this.props;
    return (
      <div
        ref={ref => this.navigationWrapRef = ref}
        className="navigation-wrap"
        style={{
          top: navigationBarHeight - 1,
          backgroundColor: backgroundColor,
          paddingLeft: `${baseConfig.moduleMarginHorizontal}px`,
          paddingRight: `${baseConfig.moduleMarginHorizontal}px`,
        }}
      >
        <ul className="img-list">
          { 
            itemImgList.map((item, index) => {
              return (
                <li key={index} className="img-item" onClick={() => this.imgNavClick(item, index)}>
                  <img src={index === this.state.select ? item.tabActiveImg : item.tabUnActiveImg} alt="" />
                </li>
              )
            })
          }
        </ul>
      </div>
    )
  }

  render() {
    const { baseConfig } = this.props.config;

    return (
      <div
        ref={ref => this.navRef = ref}
        className="pipeline-navBar"
        {...this.props['customAttributes']}
        style={{
          marginTop: `${baseConfig.moduleMarginTop}px`
        }}
      >
        {
          baseConfig.navigationStyle === '图片导航' 
            ? this.renderImgNavList()
            : this.renderDefaultNavList()
        }
      </div>
    )
  }
}

PipelineNavBar.propTypes = {
  config: PropTypes.object.isRequired,
};

export { PipelineNavBar };
export default PipelineNavBar;



// WEBPACK FOOTER //
// ./components/pipeline-navBar/index.js